module.exports = __webpack_public_path__ + "img/clopotel-alb.8f03cfbe.svg";